<div class="container">
  <div class="row">
    <div class="col-12">

      <div *ngIf="contentPopups" class="modal modal-cls" tabindex="-1" role="dialog"
        [ngStyle]="{'display':contentPopups}">
        <div class="modal-dialog" role="document ">
          <div class="modal-content modal-scroll">
            <div class="modal-header">
              <h5 class="modal-title">{{contentKey}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="closemodel('cancel')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

<div *ngIf="tablekeys" class="row">
  <div class="col-12">
       <table class="table table-bordered">
        <thead class="thead-dark">
          <tr>
            <th  *ngFor="let keys of tablekeys">
           {{keys}}
            </th>
          </tr>

        </thead>
        <tbody>
          <!-- <tr  *ngFor="let val of tablevalues">
            <td class="val_border">
             {{val}}
            </td>
          </tr> -->
          <tr *ngFor="let item of tablevalues">
            <td *ngFor="let column of tablekeys">{{item[column]}}</td>
          </tr>

        </tbody>


      </table>

    </div>
</div>

<div class="row" *ngIf="contentTableArray">
  <div class="col-12">
    <div *ngFor="let dt of contentTableArray">
     <p>{{dt}}</p>
    </div>

  </div>

</div>




              <div class="row">
                <div class="col-12 text-center">
                  <ul *ngFor="let d of content_Details" class=" m-2 text-center">
                    <li style="text-align: justify"> {{d}}</li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <div style="border-bottom: 1px solid grey" class=" m-2 text-center">
                    <p style="text-align: justify"> {{content_value}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal"
                (click)="closemodel('cancel')">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
